module.exports = __webpack_public_path__ + "img/logo-small.c2230e02.svg";